<template>
  <div class="block-infos">
    <div v-for="(info, index) in infos" :key=index>
      {{info.label}}&nbsp;: <strong v-if="info.date">{{parseDate(info.data)}}</strong><strong v-else>{{info.data}}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'block-infos',
  props: ['infos', 'theme'],
  methods: {
    parseDate(date) {
      if (typeof date !== 'undefined') {
        let d = date.split(' ')[0].split('-'),
        event = new Date(Date.UTC(d[0], d[1] - 1, d[2], 0, 0, 0)),
        options = { year: 'numeric', month: 'long', day: 'numeric' };

        return event.toLocaleDateString('fr-FR', options)
      }
    }
  },
}
</script>

<style lang="scss">
.block-infos {
  display: flex;
  flex-direction: column;
  margin: rem(15px) 0 rem(30px) 0;
  color: color(grey-dark);

  div {
    padding-left: rem(8px);
    font-size: rem(12px);
    text-align: left;
  }

  .orange & {
    border-left: 2px solid color(orange);
  }

  .blue & {
    border-left: 2px solid color(blue);
  }
}
</style>
